import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchFloor, fetchFloorGraph } from '@/lib/api/spaces.js'
import WorkspaceShell from '@/features/workspace/WorkspaceShell.jsx'
import { useSpatialStore } from '@/features/spatial-model/store.js'
import { recordRecentFloor } from '@/lib/recents.js'

export default function FloorWorkspacePage() {
  const { floorId } = useParams()
  const setFloor = useSpatialStore((s) => s.setFloor)
  const hydrateGraph = useSpatialStore((s) => s.hydrateGraph)
  const reset = useSpatialStore((s) => s.reset)

  const floorQuery = useQuery({
    queryKey: ['floor', floorId],
    queryFn: () => fetchFloor(floorId),
    enabled: !!floorId,
  })

  const graphQuery = useQuery({
    queryKey: ['floor', floorId, 'graph'],
    queryFn: () => fetchFloorGraph(floorId),
    enabled: !!floorId,
  })

  useEffect(() => {
    if (floorQuery.data) {
      setFloor(floorQuery.data)
      recordRecentFloor(floorQuery.data)
    }
  }, [floorQuery.data, setFloor])

  useEffect(() => {
    if (graphQuery.data) hydrateGraph(graphQuery.data)
  }, [graphQuery.data, hydrateGraph])

  useEffect(() => () => reset(), [reset])

  return (
    <main className="app-content app-content--workspace">
      <div style={{ padding: '16px 24px 24px', height: '100%' }}>
        <WorkspaceShell loading={floorQuery.isLoading || graphQuery.isLoading} />
      </div>
    </main>
  )
}
